export class StudentRegistration {
    public ID: number;
    public HashCode: string;
    public SchoolID: number;
    public BoardID: number;
    public STDID: number;
    public StudName: string;
    public StateID : number;
    public CityID : number;
    public Area : string;
    public MobileNo:string;
    public MailID:string;
    public CategoryID:number;
    public FatherName:string;
    public FatherMobile:string;
    public FatherMail:string;
    public MotherName:string;
    public MotherMobile:string;
    public MotherMail:string;
    public captchaEndpoint :string;
}